<template>
    <rkm-overlay>
        <rkm-layout-body title="Notificação">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({name: 'administracao-notificacao-create'})"
                    authorize="store-administracao-notificacao"
                    color="primary"
                >
                    Cadastrar notificação
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/notificacao/List'

export default {
    components: {List},
}
</script>